import React, { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import './token-details-page.scss';
import PageCard from 'containers/PageCard';
import PageHeader from 'modules/page-header';
import { useHistory } from 'react-router';
import {
  InitTokenRedemptionFooter,
  PayTokenRedemptionFooter,
  SignSubmitTokenRedeem,
  SignTokenRedemptionFooter,
  TokenDetails,
  TokenRedeemedInfo,
  TokenRedemptionOwnerResult,
  TokenRedemptionPayDetails,
  TokenRedemptionResult,
  TokenRedemptionSignDetails,
  TokenRedemptionSignPayDetails,
} from './components';
import {
  AssetStatusToFrontendState,
  MapTokenRedemptionTypeToBackendType,
  TokenRedemptionDocumentType,
  TokenRedemptionState,
  TokenRedemptionType,
} from 'constants/redemption';
import { SignFooter } from 'components';
import { SignFunction } from 'constants/app';
import { useDispatch, useSelector } from 'hooks/redux';
import AssetsApi from 'services/api/AssetsApi';
import RedemptionApi from 'services/api/RedemptionApi';
import { setPush } from 'store/actions/app';
import { Loader } from '@ru-digital-assets/ui-component';
import { createHash } from 'crypto-pro';
import { hideLoader, showLoader } from 'store/actions/loader';

export default function TokenDetailsPage() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [redemptionState, setRedemptionState] = useState<TokenRedemptionState | undefined>();
  const redemptionType = useRef<TokenRedemptionType>(
    TokenRedemptionType.execution
  );

  const accountId = useSelector((state) => state.auth.account.id);
  const assetId = history.location.state.id;
  const token = useSelector((state) => state.auth.account.token);
  const [asset, setAsset] = useState<any>();

  console.log('Status: ', asset?.status);
  console.log('redemptionState', redemptionState);

  useEffect(() => {
    if (asset?.status) {
      let state: TokenRedemptionState | undefined = AssetStatusToFrontendState[asset.status];
      if (state === TokenRedemptionState.INIT && asset.issuingInfo?.expiryDate) {
        if (new Date() < new Date(asset.issuingInfo.expiryDate)) {
          state = undefined;
        }
      }
      console.log('state {%s}; expiryDate {%s}; now {%s}', state, asset.issuingInfo?.expiryDate, new Date());
      setRedemptionState(state);
    }
  }, [asset?.status, asset?.issuingInfo?.expiryDate]);

  const updateAssetInfo = useCallback(
    (callback?: () => void) => {
      AssetsApi.getDetailedAssetInfo(token, { accountId, tokenId: assetId })
        .then((response) => {
          setAsset(response.data);
          callback && callback();
        })
        .catch(() => {
          dispatch(
            setPush({
              message: 'Не удалось загрузить информацию',
              type: 'error',
            })
          );
        });
    },
    [accountId, assetId, token]
  );

  useEffect(() => {
    updateAssetInfo();
  }, []);

  const pageTitle = useMemo(() => {
    if (asset)
      if (asset.isIssuer) {
        switch (redemptionState) {
          case TokenRedemptionState.SIGN_TRANSACTION:
            return 'Подпишите транзакцию';
          case TokenRedemptionState.PAY:
            return 'Оплатите задолженность по токенам и отправьте подтверждение Обладателю';
          case TokenRedemptionState.SIGN_PAY:
            return redemptionType.current === TokenRedemptionType.execution
              ? 'Подпишите уведомление об исполнении обязательств'
              : 'Подпишите заявление о прекращении обязательств';
          case TokenRedemptionState.RESULT:
            return 'Погашение токенов';
          case TokenRedemptionState.PAYMENT_SIGNED:
          case TokenRedemptionState.OWNER_SIGN_TRANSACTION:
            return 'Инициирована операция погашения. Дождитесь подтверждения оплаты Обладателем токена';
          default:
            return 'Токен';
        }
      } else {
        switch (redemptionState) {
          case TokenRedemptionState.PAYMENT_SIGNED:
            return redemptionType.current === TokenRedemptionType.execution
              ? 'Подпишите заявление о надлежащем исполнении обязательств Эмитентом'
              : 'Подпишите заявление о признании обязательств Эмитента прекратившимися';
          case TokenRedemptionState.OWNER_SIGN_TRANSACTION:
            return 'Подпишите транзакцию';
          default:
            return 'Токен';
        }
      }
    return undefined;
  }, [redemptionState, redemptionType, asset]);

  const pageTitleColor = useMemo(() => {
    if (asset) {
      if (asset.isIssuer) {
        switch (redemptionState) {
          case TokenRedemptionState.INIT:
          case TokenRedemptionState.RESULT:
            return '#181818';
          case TokenRedemptionState.PAYMENT_SIGNED:
          case TokenRedemptionState.OWNER_SIGN_TRANSACTION:
          case TokenRedemptionState.SIGN_TRANSACTION:
          case TokenRedemptionState.PAY:
          case TokenRedemptionState.SIGN_PAY:
            return '#FF5C00';
          default:
            return '#181818';
        }
      } else {
        switch (redemptionState) {
          case TokenRedemptionState.PAYMENT_SIGNED:
          case TokenRedemptionState.OWNER_SIGN_TRANSACTION:
            return '#FF5C00';
          default:
            return '#181818';
        }
      }
    }
    return undefined;
  }, [redemptionState, asset]);

  const onSubmitInitRedemption = useCallback((selectedRedemptionType) => {
    redemptionType.current = selectedRedemptionType;
    setRedemptionState(TokenRedemptionState.SIGN_TRANSACTION);
  }, []);

  const onSubmitSignTransaction = useCallback(
    (privateKey: string) => {
      dispatch(showLoader());
      RedemptionApi.initRedeem(token, {
        tokenId: assetId,
        privateKey,
        type: MapTokenRedemptionTypeToBackendType[redemptionType.current],
      })
        .then(() => {
          updateAssetInfo();
        })
        .catch(() => {
          dispatch(
            setPush({
              message: 'Ошибка при инициализации погашения токена',
              type: 'error',
            })
          );
        })
        .finally(() => {
          dispatch(hideLoader());
        });
    },
    [updateAssetInfo, assetId]
  );

  const onSubmitPayDocument = useCallback(
    (file: File, date: Date, reason?: string) => {
      dispatch(showLoader());
      RedemptionApi.uploadPaymentDocument(token, assetId, date, file)
        .then(() => {
          updateAssetInfo();
        })
        .catch(() => {
          dispatch(
            setPush({
              message: 'Ошибка при загрузке документа',
              type: 'error',
            })
          );
        })
        .finally(() => {
          dispatch(hideLoader());
        });
    },
    [assetId, updateAssetInfo]
  );

  const onSignPay = useCallback(
    (signFunc: SignFunction) => {
      dispatch(showLoader());
      RedemptionApi.getRedeemDocument(token, assetId, asset.isIssuer ?
        TokenRedemptionDocumentType.NOTIFY_REDEEM_DOC :
        TokenRedemptionDocumentType.AGREEMENT_DOC)
        .then((response) => {
          const document = response.data;
          createHash(document)
            .then((documentHash) => {
              signFunc(documentHash).then(({ pdfSigned: signature }) => {
                if (signature) {
                  const requestDto = {
                    tokenId: assetId,
                    hash: documentHash,
                    signature: signature,
                    accountId: accountId,
                  };
                  createHash(JSON.stringify(requestDto)).then((checksum) => {
                    RedemptionApi.signRedeemPaymentNotification(token, {
                      checksum,
                      ...requestDto,
                    })
                      .then(() => {
                        if (redemptionState === TokenRedemptionState.SIGN_PAY) {
                          setRedemptionState(TokenRedemptionState.RESULT);
                        } else {
                          updateAssetInfo();
                        }
                        dispatch(hideLoader());
                      })
                      .catch(() => {
                        dispatch(hideLoader());
                        dispatch(
                          setPush({
                            message: 'Ошибка при отправке подписи',
                            type: 'error',
                          })
                        );
                      });
                  });
                }
              });
            })
            .catch(() => {
              dispatch(hideLoader());
              dispatch(
                setPush({
                  message: 'Ошибка при подписи документа',
                  type: 'error',
                })
              );
            });
        })
        .catch(() => {
          dispatch(hideLoader());
          dispatch(
            setPush({
              message: 'Ошибка при загрузке документа',
              type: 'error',
            })
          );
        });
    },
    [assetId, accountId, redemptionState, updateAssetInfo]
  );

  const onOwnerSignTransaction = useCallback(
    (privateKey: string) => {
      dispatch(showLoader());
      RedemptionApi.approveRedeem(token, {
        tokenId: assetId,
        privateKey,
      })
        .then(() => {
          setRedemptionState(TokenRedemptionState.OWNER_RESULT);
        })
        .catch(() => {
          dispatch(
            setPush({
              message: 'Ошибка при подтверждении погашения токена',
              type: 'error',
            })
          );
        })
        .finally(() => {
          dispatch(hideLoader());
        });
    },
    [updateAssetInfo, assetId, redemptionState]
  );

  const onClose = useCallback(() => {
    history.push('/assets');
  }, []);

  return (
    <div className="token-details-page">
      <div className="container">
        <PageHeader
          items={[
            { link: '/assets', title: 'Активы' },
            {
              link: '/assets',
              title: 'Выпущенные ЦФА',
            },
            {
              link: '#',
              title: 'Токен',
            },
          ]}
          iconType="assets"
          isHideBalanceInformer
        />
        {asset ? (
          <PageCard
            minHeight={'calc(100vh - 100px)'}
            title={pageTitle}
            titleColor={pageTitleColor}
            main={
              asset.isIssuer ? (
                redemptionState === TokenRedemptionState.INIT ||
                  redemptionState === TokenRedemptionState.PAYMENT_SIGNED ? (
                  <TokenDetails asset={asset} />
                ) : redemptionState === TokenRedemptionState.SIGN_TRANSACTION ? (
                  <TokenRedemptionSignDetails
                    asset={asset}
                    redemptionType={redemptionType.current!}
                  />
                ) : redemptionState === TokenRedemptionState.PAY ? (
                  <TokenRedemptionPayDetails
                    asset={asset}
                    redemptionType={redemptionType.current!}
                  />
                ) : redemptionState === TokenRedemptionState.SIGN_PAY ? (
                  <TokenRedemptionSignPayDetails
                    asset={asset}
                    redemptionType={redemptionType.current!}
                  />
                ) : redemptionState === TokenRedemptionState.RESULT ? (
                  <TokenRedemptionResult asset={asset} />
                ) : redemptionState === TokenRedemptionState.REDEEMED ? (
                  <TokenRedeemedInfo
                    asset={asset}
                    redemptionType={redemptionType.current}
                  />
                ) : (
                  <TokenDetails asset={asset} />
                )
              ) : redemptionState === TokenRedemptionState.PAYMENT_SIGNED ||
                redemptionState === TokenRedemptionState.OWNER_SIGN_TRANSACTION ? (
                <SignSubmitTokenRedeem
                  redemptionType={redemptionType.current}
                  asset={asset}
                />
              ) : redemptionState === TokenRedemptionState.OWNER_RESULT ? (
                <TokenRedemptionOwnerResult asset={asset} />
              ) : redemptionState === TokenRedemptionState.REDEEMED ? (
                <TokenRedeemedInfo
                  asset={asset}
                  redemptionType={redemptionType.current}
                />
              ) : (
                <TokenDetails asset={asset} />
              )
            }
            footer={
              asset.isIssuer ? (
                redemptionState === TokenRedemptionState.INIT && !asset.isOwner ? (
                  <InitTokenRedemptionFooter
                    onCancel={onClose}
                    onSubmit={onSubmitInitRedemption}
                  />
                ) : redemptionState === TokenRedemptionState.SIGN_TRANSACTION ? (
                  <SignTokenRedemptionFooter
                    onCancel={() => setRedemptionState(TokenRedemptionState.INIT)}
                    onSign={onSubmitSignTransaction}
                    label={
                      <>
                        Вы инициируете погашение токенов на сумму: {asset.financialClaim} ₽
                      </>
                    }
                  />
                ) : redemptionState === TokenRedemptionState.PAY ? (
                  <PayTokenRedemptionFooter
                    onSubmit={onSubmitPayDocument}
                    redemptionType={redemptionType.current!}
                  />
                ) : redemptionState === TokenRedemptionState.SIGN_PAY ? (
                  <SignFooter
                    signButtonText={
                      redemptionType.current === TokenRedemptionType.execution
                        ? 'Подписать Уведомление об исполнении обязательств'
                        : 'Подписать Заявление о прекращении обязательств'
                    }
                    onSign={onSignPay}
                  />
                ) : null
              ) : redemptionState === TokenRedemptionState.PAYMENT_SIGNED ? (
                <SignFooter
                  signButtonText={
                    redemptionType.current === TokenRedemptionType.execution
                      ? 'Подписать Уведомление об исполнении обязательств'
                      : 'Подписать Заявление о прекращении обязательств'
                  }
                  onSign={onSignPay}
                />
              ) : redemptionState ===
                TokenRedemptionState.OWNER_SIGN_TRANSACTION ? (
                <SignTokenRedemptionFooter
                  onSign={onOwnerSignTransaction}
                  label={<>Вы подтверждаете погашение токенов на сумму: {asset.actualCount * asset.tokenPrice} ₽</>}
                />
              ) : null
            }
            onClose={onClose}
          />
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
}
